
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import axios from 'axios'
import App from './App'
import '../theme/index.css'
import '../theme/index-rtl.css'
import './assets/font-awesome/css/font-awesome.min.css'
import './assets/styles/font.css'
import router from './router'
import IdleVue from 'idle-vue'
import Google from './google.js'
import Countries from './countries.js'
import Session from './session.js'
import { EventBus } from './event-bus.js'

Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(Google)
Vue.use(Countries)
Vue.use(Session)
Vue.use(IdleVue, {eventEmitter: EventBus, idleTime: 60000 * 15})
window.EventBus = EventBus // Temporarily added for dubugging...
const i18n = new VueI18n({
  locale: 'en',
  messages: {}
})
Vue.config.productionTip = false
Vue.END_POINT = process.env.END_POINT
Vue.AWS_ASSETS = process.env.AWS_ASSETS
Vue.PUSHER_KEY = process.env.PUSHER_KEY
Vue.prototype.$google = process.env.GOOGLE_API

Vue.AWS_FOLDERS = {
  student: '/pictures/students/thumbnails/',
  guardian: '/pictures/guardians/thumbnails/',
  configuration: '/pictures/configuration/thumbnails/',
  bus: '/documents/buses/',
  driver: '/pictures/drivers/thumbnails/',
  supervisor: '/pictures/supervisors/thumbnails/',
  user: '/pictures/users/thumbnails/',
  license: '/pictures/licenses/thumbnails/',
  incident: '/pictures/incidents/',
  message: '/attachments/messages/'
}

function renderVue () {
  return new Vue({
    el: '#app',
    i18n,
    router,
    template: '<App/>',
    components: { App }
  })
}

let host = window.location.host.toUpperCase()
let domain = host.split('.')
if (domain.length > 1) {
  let AccessCode = domain[0]
  if (domain.length === 4) AccessCode += '.' + domain[1]
  axios.get(process.env.APP_API + '/' + AccessCode + '-WEB').then((response) => {
    Vue.END_POINT = response.data.app_config.endpoint
    Vue.AWS_ASSETS = response.data.app_config.asset_path
    Vue.PUSHER_KEY = response.data.app_config.pusher_key
    Vue.prototype.$google = response.data.app_config.google_api
    renderVue()
  }).catch((response) => {
    renderVue()
  })
} else {
  renderVue()
}



// WEBPACK FOOTER //
// ./src/main.js